import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import axios from "axios";
import { getMyPermissions } from "../services/userServices";
import useAuth from "../hooks/useAuth";
import { toast } from "react-toastify";

const PermissionsContext = createContext();

export const PermissionsProvider = ({ children }) => {
  const [permissions, setPermissions] = useState(null);
  const { auth } = useAuth();

  const permissionsList = useCallback(async () => {
    try {
      const response = await getMyPermissions();
      setPermissions(response.data.permissions);
      
    } catch (err) {
      if (!err?.response) {
        toast.error("No responde el servidor");
      }
    }
  }, []);

  useEffect(() => {
    
    if (auth?.accessToken) {
      permissionsList();
    } else {
      setPermissions(null);
    }
  }, [auth?.accessToken, permissionsList]);

  return (
    <PermissionsContext.Provider value={permissions}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionsContext);
